module.exports = __webpack_public_path__ + "img/download(1).ee4c7080.jpg";